import "./partials/helpers/chatDebug";
import { chatBubble } from "./partials/components/chatBubble";
import { chatContent } from "./partials/components/chatContent";
import { chatSessions } from "./partials/components/chatSessions";
import { archiveModal } from "./partials/components/archiveModal";
import { creditsModal } from "./partials/components/creditsModal";
import { playMessage } from "./partials/actions/playMessage";
import { pinMessage } from "./partials/actions/pinMessage";
import { pinsBtn, initPinsDeepLink } from "./partials/actions/pinsBtn";
import { evaluateMessage } from "./partials/actions/evaluateMessage";
import { deleteMessage } from "./partials/actions/deleteMessage";
import { deletePinnedMessage } from "./partials/actions/deletePinnedMessage";
import { regenerateMessage } from "./partials/actions/regenerateMessage";
import { branchMessage } from "./partials/actions/branchMessage";
import { infoModal } from "./partials/components/infoModal";
import { chatProfile } from "./partials/components/chatProfile";
import { messageActions } from "./partials/components/messageActions";
import { renderAudio } from "./partials/actions/renderAudio";
import { lockedFeatureModal } from "./partials/components/lockedFeatureModal";
import { imageWrapper } from "./partials/actions/imageWrapper";
import { shareMessage } from "./partials/actions/shareMessage";
import { chatLevel } from "./partials/components/chatLevel";
import { chatMemory } from "./partials/components/chatMemory";
import { exitIntent } from "./partials/components/exitIntent";
import { unlockContent } from "./partials/actions/unlockContent";
import { pwaBadge } from "./partials/components/pwaBadge";
import { videoDebug } from "./partials/components/videoDebug";
import { chatMysteryBox } from "./partials/components/chatMysteryBox";
import { rewriteChatUrl } from "./partials/actions/rewriteChatUrl";
import { roleplayToggle } from "./partials/components/roleplayToggle";
import { chatSettings } from "./partials/components/chatSettings";
import { initMessageDetails } from "./partials/components/messageDetails";
import { initSessionDetails } from "./partials/components/sessionDetails";
import { initMessageMemoryRecall } from "./partials/components/messageMemoryRecall";
import { initChatGlobalLoader } from "./partials/components/chatGlobalLoader";
import { initAsyncRoleplayOpeningImages } from "./partials/actions/asyncRoleplayOpeningImage";
import { initProfileRequiredAjaxGuard } from "./partials/actions/handleAjaxError";
// Side-effect import — registers global capture-phase click listeners
import "./partials/components/btnUseAsReference";

window.growtypeChatAudioWaveColor = "white";
window.growtypeChatAudioProgressColor = "#b9b9b9";

function initializeStandaloneChatSettings() {
  const $chatSettingsTargets = jQuery(
    ".chat-settings-memories, .woocommerce-EditAccountForm"
  );

  if (!$chatSettingsTargets.length) {
    return false;
  }

  const hasAjaxConfig =
    !!window.growtype_chat_ajax?.memories_list_action &&
    !!window.growtype_chat_ajax?.url;

  const alreadyInitialized = $chatSettingsTargets
    .toArray()
    .every((element) => jQuery(element).attr("data-chat-settings-initialized") === "true");

  if (alreadyInitialized && hasAjaxConfig) {
    return true;
  }

  chatSettings();

  const initializedWithConfig =
    !!window.growtype_chat_ajax?.memories_list_action &&
    !!window.growtype_chat_ajax?.url;

  $chatSettingsTargets.attr(
    "data-chat-settings-initialized",
    initializedWithConfig ? "true" : "pending"
  );

  return initializedWithConfig;
}

jQuery(function ($) {
  initProfileRequiredAjaxGuard();
  initChatGlobalLoader();
  initAsyncRoleplayOpeningImages();
  roleplayToggle();
  /**
   * Fires immediately to avoid seeing the token URL.
   */
  // rewriteChatUrl();

  /**
   * Image wrapper
   */
  imageWrapper();

  /**
   * Play message
   */
  playMessage($(".g-chatform-message-play"));

  /**
   * Pin message
   */
  pinMessage($(".g-chatform-message-pin"));

  /**
   * Pins button + pinned page deep-link
   */
  pinsBtn($(".g-chat-btn-pins"));
  initPinsDeepLink();

  /**
   * Evaluate message
   */
  evaluateMessage(
    $(".g-chatform-message-feedback .g-chatform-message-actions-options-single")
  );

  /**
   * Delete message
   */
  deletePinnedMessage($(".g-chatform-pinned .g-chatform-message-delete"));
  deleteMessage($(".g-chatform:not(.g-chatform-pinned) .g-chatform-message-delete"));

  /**
   * Regenerate message
   */
  regenerateMessage($(".g-chatform-message-regenerate"));
  branchMessage();

  /**
   * Share message
   */
  shareMessage($(".g-chatform-message-share"));

  /**
   * Message actions
   */
  messageActions($(".g-chatform-message-actions-selector"));

  /**
   * Render audio
   */
  renderAudio($(".g-chatform-content .audio-message"));

  /**
   * Use credits
   */
  creditsModal();

  /**
   * Info modal and reload-safe #info deep link
   */
  infoModal();

  /**
   * Locked modal
   */
  lockedFeatureModal();

  /**
   * Load chat bubble
   */
  chatBubble();

  /**
   * Chat sessions
   */
  chatSessions();
  archiveModal();

  /**
   * Chat content
   */
  chatContent();

  /**
   * Chat profile
   */
  chatProfile();

  /**
   * Standalone account chat settings page
   */
  initializeStandaloneChatSettings();

  if (typeof MutationObserver !== "undefined") {
    const chatSettingsObserver = new MutationObserver((mutations) => {
      const hasChatSettingsMarkup = mutations.some((mutation) =>
        Array.from(mutation.addedNodes || []).some((node) => {
          if (!(node instanceof Element)) {
            return false;
          }

          return (
            node.matches?.(".chat-settings-memories, .woocommerce-EditAccountForm") ||
            node.matches?.("#growtype-chat-account-ajax-data") ||
            node.querySelector?.(".chat-settings-memories, .woocommerce-EditAccountForm") ||
            node.querySelector?.("#growtype-chat-account-ajax-data")
          );
        })
      );

      if (hasChatSettingsMarkup && initializeStandaloneChatSettings()) {
        chatSettingsObserver.disconnect();
      }
    });

    chatSettingsObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  /**
   * Level
   */
  chatLevel();

  /**
   * Memory animation
   */
  chatMemory();

  /**
   * Exit intent
   */
  exitIntent();

  /**
   * Unlock content
   */
  unlockContent();

  /**
   * PWA Badge
   */
  pwaBadge();

  /**
   * Mystery Box
   */
  chatMysteryBox($(".btn-open-mystery-box"));

  /**
   * Debug Details
   */
  initMessageDetails();
  initMessageMemoryRecall();
  initSessionDetails();
});
